import { MdOutlineInfo } from 'react-icons/md';
import { AircraftIcon, CarGroundIcon } from '@icons';
import { MultiSuggestRouteItem } from '@lp/features/MultiSuggest';
import { TransportType } from '@lp/features/RoutePlanner/components/TransportType';
import { Tooltip } from '@heroui/react';
import { msToFixedHours } from '@/utils/helpers';
import { GROUND_LEG_TYPES } from '@/utils/route';

const GROUND_ROUTE_TOOLTIP_TEXT =
  'Driving hours reflect only the displayed route segments and do not include custom segments or Curri Service/TEDS legs.';

type ProviderInfoProps = Omit<MultiSuggestRouteItem, 'segments'>;

export const ProviderInfo = ({
  providerType,
  title,
  routeDurationInMs,
  blockTimeRouteDurationInMs,
}: ProviderInfoProps) => {
  const isGround = GROUND_LEG_TYPES.includes(providerType);
  const icon = isGround ? <CarGroundIcon /> : <AircraftIcon />;
  const routeDurationTime = routeDurationInMs ? msToFixedHours(routeDurationInMs) : null;
  const routeDurationBlockTime = msToFixedHours(blockTimeRouteDurationInMs);
  const routeDurationTimeString = routeDurationTime ? `${routeDurationTime} / ` : '';
  const showTransportType = !isGround;

  return (
    <div className="flex items-center">
      <div className="flex items-center gap-1">
        {showTransportType && <TransportType legType={providerType} />}
        {icon}
      </div>
      {!!title && <span className="text-s-sb text-base-10 ml-2">{title}</span>}
      <span className="text-m-sb text-black ml-4">{`${routeDurationTimeString}${routeDurationBlockTime}`}</span>
      {isGround && (
        <Tooltip className="max-w-80" content={GROUND_ROUTE_TOOLTIP_TEXT} showArrow closeDelay={0}>
          <div className="ml-1 text-black cursor-pointer">
            <MdOutlineInfo size={16} />
          </div>
        </Tooltip>
      )}
    </div>
  );
};
